import { render, staticRenderFns } from "./MainContentAbout.vue?vue&type=template&id=f6082afe&scoped=true&lang=pug&"
import script from "./MainContentAbout.vue?vue&type=script&lang=js&"
export * from "./MainContentAbout.vue?vue&type=script&lang=js&"
import style0 from "./MainContentAbout.vue?vue&type=style&index=0&id=f6082afe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6082afe",
  null
  
)

export default component.exports